import { useNavigate } from "react-router-dom";

// @mui material components
import Divider from "@mui/material/Divider";

// Argon Dashboard components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";

// Auth context
import { useAuth } from "contexts/AuthContext";

function SidenavFooter() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/authentication/sign-in");
  };

  if (!user) return null;

  return (
    <ArgonBox mt="auto">
      <Divider />
      <ArgonBox pt={2} pb={1} px={3}>
        <ArgonBox display="flex" alignItems="center" mb={1}>
          <ArgonBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="2rem"
            height="2rem"
            borderRadius="50%"
            backgroundColor="info"
            mr={1}
          >
            <ArgonTypography variant="button" color="white" fontWeight="bold">
              {user.full_name ? user.full_name.charAt(0).toUpperCase() : "U"}
            </ArgonTypography>
          </ArgonBox>
          <ArgonBox>
            <ArgonTypography variant="button" fontWeight="medium" color="text">
              {user.full_name || "User"}
            </ArgonTypography>
            <ArgonTypography variant="caption" color="text" display="block">
              {user.email}
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
        <ArgonButton
          variant="outlined"
          color="dark"
          size="small"
          fullWidth
          onClick={handleLogout}
        >
          Sign Out
        </ArgonButton>
      </ArgonBox>
    </ArgonBox>
  );
}

export default SidenavFooter;
